module.exports = __webpack_public_path__ + "static/media/IMG_3593.ed11b65c.jpg";